module.exports = __webpack_public_path__ + "static/media/host-register-img.422f6696.png";